import { useSelector } from 'react-redux';

import { getErrorByActionName } from '../selectors/errors';

export const useErrorByActionName = (actionName: string): string | undefined =>
  useSelector(getErrorByActionName(actionName));
